import { render, staticRenderFns } from "./LocalImageSelector.vue?vue&type=template&id=dbc001ac&scoped=true"
import script from "./LocalImageSelector.vue?vue&type=script&lang=ts"
export * from "./LocalImageSelector.vue?vue&type=script&lang=ts"
import style0 from "./LocalImageSelector.vue?vue&type=style&index=0&id=dbc001ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc001ac",
  null
  
)

export default component.exports